import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"10px","text-align":"left"} }
const _hoisted_2 = { style: {"padding":"20px"} }

import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { allSite, delSite, addSite} from '../../api'
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'siteList',
  setup(__props) {

  const search = reactive({
    key: "",
  })
  
  
  const loading = ref(false);
  const dataSource = ref([]);
  
  const selectedKeys = ref([]);
  
  const page = reactive({ current: 1, limit: 10, total: 0 });
  
  const columns = ref([
    { title: "站点名称", key: "siteName", align: "center", width: "130px" },
    { title: "网站域名", key: "website", align: "center" },
    { title: "网站api", key: "websiteApi", align: "center" },
    { title: "访问标识", key: "accessId", align: "center"  , ellipsisTooltip: true},
    { title: "站点标识", key: "siteId", align: "center"},    
    { title: "解密key", key: "key", align: "center"}, 
    { title: "解密IV", key: "iv", align: "center"}, 
    { title: "备注", key: "remark", align: "center" },
    { title: "添加时间", key: "addTime", align: "center" },
    { title: "操作", customSlot: "operator", key: "operator", width: "100px", fixed: "right", align: "center" }
  ]);
  
  
  const getAllSite = () => {
    loading.value = true;
    var data = { "page": page.current, "limit": page.limit, "key": search.key };
    allSite(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllSite();
  
  
  const change = (page: any) => {
    getAllSite();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
  
 
const setDelSite=(res: any)=>{
    var data={'id':res.id}
    delSite(JSON.stringify(data)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllSite();
            visible11.value = false;
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })

}


  
  //查询接口
  const searchUser = () => {
    page.current=1;
    getAllSite();
  }
  
  
  
  const site = reactive({
    siteName: "",
    website: "",
    id: 0,
    websiteApi:'',
    accessId:'',
    siteId:0,
    key:'',
    iv:'',
    remark:'',
  })
  
  
  const updateSite = (row: any) => {
    site.siteName = row.siteName;
    site.remark = row.remark; 
    site.website= row.website; 
    site.websiteApi= row.websiteApi; 
    site.siteId= row.siteId; 
    site.key= row.key; 
    site.iv= row.iv; 
    site.id= row.id; 
    site.accessId= row.accessId;  
    visible11.value = !visible11.value;
  }
  
 

  const layFormRef11 = ref();
  
  const visible11 = ref(false); 
  
  const addSiteData = () => {
    site.siteName = '';
    site.remark = '';
    site.website='';
    site.websiteApi= '';
    site.siteId= 0;
    site.key= '';
    site.iv= '';
    site.id= 0;
    site.accessId= '';
    visible11.value = !visible11.value;
  }
  
  const action11 = ref([
    {
      text: "确认",
      callback: () => {
        addSite(JSON.stringify(site)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllSite();
            visible11.value = false;
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
      }
    },
    {
      text: "取消",
      callback: () => {
        visible11.value = false;
  
  
      }
    }
  ])
  
  
  
return (_ctx: any,_cache: any) => {
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_textarea = _resolveComponent("lay-textarea")!
  const _component_lay_layer = _resolveComponent("lay-layer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "24" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_form, {
                  model: search,
                  style: {"text-align":"start"},
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lay_form_item, {
                      label: "节点",
                      prop: "username",
                      mode: "inline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: search.key,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.key) = $event)),
                          placeholder: "请输入节点名称"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, { mode: "inline" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_button, {
                          type: "primary",
                          size: "sm",
                          onClick: searchUser
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("查询")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_lay_button, {
                    size: "sm",
                    onClick: addSiteData,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新增")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_lay_table, {
                  page: page,
                  height: '100%',
                  columns: columns.value,
                  loading: loading.value,
                  "data-source": dataSource.value,
                  "selected-keys": selectedKeys.value,
                  "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((selectedKeys).value = $event)),
                  onChange: change,
                  onSortChange: sortChange
                }, {
                  operator: _withCtx(({ row }) => [
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (updateSite(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (setDelSite(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lay_layer, {
      modelValue: visible11.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((visible11).value = $event)),
      shade: false,
      area: ['500px', '680px'],
      btn: action11.value,
      title: "添加/修改"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_lay_form, {
            model: site,
            ref_key: "layFormRef11",
            ref: layFormRef11
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "站点名称",
                prop: "siteName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: site.siteName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((site.siteName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "网站域名",
                prop: "website"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: site.website,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((site.website) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "网站api",
                prop: "websiteApi"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: site.websiteApi,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((site.websiteApi) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "访问标识",
                prop: "accessId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: site.accessId,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((site.accessId) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "站点标识",
                prop: "siteId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: site.siteId,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((site.siteId) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "解密key",
                prop: "key"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: site.key,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((site.key) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "解密IV",
                prop: "iv"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: site.iv,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((site.iv) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "备注",
                prop: "remark"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_textarea, {
                    placeholder: "请输入描述",
                    modelValue: site.remark,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((site.remark) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"])
  ], 64))
}
}

})